import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  enviroment = environment.BASE_URL;
  respuestaGet:any;
  datosCliente:any;
  tipoUsuario:any;


  constructor(private router: Router, private _get:LoginService) { 
    if (!localStorage.getItem('token')) {// si no retorna un token se redirecciona al login
      console.log('redirigiendo')
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    this.datosCliente = {
      acceso_pagos: 0
    }
    this.getDataCliente();
    
  }

  getDataCliente(){
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.tipoUsuario = this.datosCliente.tipo;
          if(this.datosCliente.is_staff == false){
            this.router.navigate(['elegir-paquete']);
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  async closeSesion() {
    this._get.cerrarSesion();
    await this.router.navigate(['/']);
  }
}
